export default __webpack_public_path__ + "static/media/checkout-lock.2af02996.svg";